/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable import/no-extraneous-dependencies */
import { Button } from "@repo/ui";
import { useUser } from "hooks/use-user";
import moment from "moment";

export default function SLACell({ dataItem }) {
  const user = useUser();
  const isCCA =
    user.Roles.includes("Call Center Agent") || user.Roles.includes("CCA");
  let bgColor = "white";
  let textColor = "black";
  let status = "";
  if (dataItem.sla && !isCCA) {
    status = "No SLA";
  }
  if (
    dataItem.sla &&
    !isCCA &&
    (dataItem?.activityType === "First Line Maintenance" ||
      dataItem?.serviceType === "First Line Maintenance" ||
      dataItem?.activityType === "Phone Support" ||
      dataItem?.serviceType === "Phone Support")
  ) {
    const hours = moment(dataItem.sla, "HH:mm").get("hours");
    const minutes = moment(dataItem.sla, "HH:mm").get("minutes");
    const duration = hours * 60 + minutes;

    if (duration < 60) {
      bgColor = "#2A9D8F";
      textColor = "#FAFAFA";
      status = "Within SLA";
    } else if (duration < 90) {
      bgColor = "#F4A261";
      textColor = "#3D2C1E";
      status = "Warning";
    } else if (duration < 120) {
      bgColor = "#8D6E63";
      textColor = "#F5F5F5";
      status = "About To Breach";
    } else if (duration >= 120) {
      bgColor = "#E63946";
      textColor = "#FFFFFF";
      status = "Breached";
    }
  }
  return (
    <td>
      <div className="flex items-center justify-center">
        {dataItem.sla ? (
          <Button
            title={`${status} (${dataItem.slaText})`}
            variant="outline"
            style={{ backgroundColor: bgColor, color: textColor }}
          >
            {dataItem.sla}
          </Button>
        ) : (
          <></>
        )}
      </div>
    </td>
  );
}
